import { getLogger } from '@stream-io/video-react-sdk';
import { ComponentType, isValidElement, ReactElement } from 'react';

export const isComponentType = <T extends object>(
  elementOrComponent?: ComponentType<T> | ReactElement | null
): elementOrComponent is ComponentType<T> => {
  return elementOrComponent === null ? false : !isValidElement(elementOrComponent);
};

export const createCallControlHandler = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: any,
  handler: () => Promise<void>
): (() => Promise<void>) => {
  const logger = getLogger(['react-sdk']);

  return async () => {
    try {
      await handler();
    } catch (error) {
      if (props.onError) {
        props.onError(error);
        return;
      }

      if (!isNotAllowedError(error)) {
        logger('error', 'Call control handler failed', error);
      }
    }
  };
};

function isNotAllowedError(error: unknown): error is DOMException {
  return error instanceof DOMException && error.name === 'NotAllowedError';
}
